import { Select } from '@bancobarigui/barihaus';

interface DecimalPlacesSelectorProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
}

export function DecimalPlacesSelector({
  value,
  onChange,
  label = 'Casas decimais',
}: DecimalPlacesSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-600 mb-2">
        {label}
      </label>
      <Select
        size="middle"
        value={String(value)}
        onChange={(val) => onChange(Number(val))}
        options={[
          { value: '0', label: '0', disabled: false },
          { value: '1', label: '1', disabled: false },
          { value: '2', label: '2', disabled: false },
          { value: '3', label: '3', disabled: false },
          { value: '4', label: '4', disabled: false },
          { value: '5', label: '5', disabled: false },
        ]}
      />
    </div>
  );
}
